import { FormItemProps } from "@/shared/form/form";
import { createContext, ReactNode, useContext } from "react";

const Context = createContext<FormItemProps | null>(null);

export type DynamicAttributeFieldFormItemProviderProps = FormItemProps & {
  children: ReactNode;
};

export function DynamicAttributeFieldFormItemProvider({
  children,
  ...rest
}: DynamicAttributeFieldFormItemProviderProps) {
  return <Context.Provider value={rest}>{children}</Context.Provider>;
}

export function useFormItemProps() {
  return useContext(Context);
}
